import endpoints from '../../API/endpoints'
import callFileAPI from '../../API/callFileAPI'
import { useAuth0 } from '../../contexts/auth0-context'
import { useQuery } from 'react-query'

const ONE_MINUTE = 1000 * 60
const FIVE_MINUTES = ONE_MINUTE * 5

export type DraftFile = Blob

export const useGetDraftFile = (draftId: string) => {
    const { getTokenSilently } = useAuth0()

    const getDraftFile = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.downloadDraftFile
            const response = await callFileAPI(url + draftId, method, token)
            return response
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<DraftFile>(['draftFile', draftId], getDraftFile, {
        enabled: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
    })
}
